import get from 'lodash/get';
import { DeviationTypes } from '../types/deviation';
import { usePrimaryTier } from '../Tier/PrimaryTierContext';
import { isSimpleDeviation, getDeviationType } from '../DeviationViews/_helpers';
export default function useDeviationStats(deviation) {
    const isComplexType = !isSimpleDeviation(deviation);
    const primaryTier = usePrimaryTier(deviation);
    return {
        faves: get(deviation, 'stats.favourites', 0),
        isFavouritable: isComplexType,
        comments: get(deviation, 'stats.comments', 0),
        isCommentable: deviation.isCommentable,
        views: get(deviation, 'stats.views', 0),
        viewsToday: get(deviation, 'extended.stats.today', 0),
        isViewCountable: isComplexType,
        subscribers: get(primaryTier || deviation, 'tier.stats.subscribers'),
        isSubscribable: getDeviationType(deviation) === DeviationTypes.TIER,
        isInSubscription: !!primaryTier,
        privatelyCollected: get(deviation, 'stats.privatelyCollected', 0),
        hasTooltips: isComplexType
    };
}
